import { ModalId } from "../../../enums/modalId";
import { setOpenedModalId } from "../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../redux/store/store";

const handleGoToPayerPortalInNewTab = (url: string) => {
  window.open(url, "_blank");
};

const handleViewDraft = (dispatch: AppDispatch) => {
  dispatch(setOpenedModalId({ id: ModalId.IMAGE_VIEWER_MODAL }));
};

export { handleGoToPayerPortalInNewTab, handleViewDraft };
